export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s δεν επιλέχθηκε';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s δεν μπορεί να είναι κενό';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s είναι υποχρεωτικό πεδίο';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s δεν συμπληρώθηκε σωστά';
                break;

            case 'opt-in':
                translation = 'Παρακαλούμε επιλέξτε το πλαίσιο για να συνεχίσετε';
                break;

            default:
                translation = 'Αυτό το πεδίο δεν συμπληρώθηκε σωστά';
                break;
        }

        return translation;
    }
}
